import { motion } from 'motion/react';

import { Stamp } from './Stamp.js';

const APP_URL = import.meta.env.VITE_APP_URL ?? 'http://localhost:5273';

export function Hero() {
  return (
    <section
      id="top"
      className="relative overflow-hidden border-b border-[var(--border-subtle)]"
    >
      {/* Linhas pautadas como ornamentação editorial; escondidas no mobile */}
      <div
        aria-hidden
        className="ruled-bg pointer-events-none absolute inset-0 hidden opacity-50 sm:block"
      />

      <div className="relative mx-auto grid max-w-6xl gap-12 px-6 pb-24 pt-20 lg:grid-cols-[1.4fr_1fr] lg:items-center lg:gap-16 lg:pb-32 lg:pt-28">
        <div>
          <div className="flex flex-wrap items-baseline gap-3">
            <Stamp variant="suggestion">manuscrito em produção</Stamp>
            <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--ink-tertiary)]">
              v0.2 · construído com você
            </span>
          </div>

          <motion.h1
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
            className="mt-6 font-serif text-[44px] font-medium leading-[1.04] tracking-[-0.02em] text-[var(--ink-primary)] sm:text-[56px] lg:text-[68px]"
          >
            Seu LinkedIn merece
            <br />
            mais que conselho{' '}
            <span className="relative inline-block">
              genérico
              <motion.span
                aria-hidden
                className="absolute inset-x-0 bottom-[0.1em] -z-0 h-[14px] bg-[var(--accent-saffron-bg)] sm:h-[18px]"
                initial={{ scaleX: 0, originX: 0 }}
                animate={{ scaleX: 1 }}
                transition={{ delay: 0.5, duration: 0.45, ease: 'easeOut' }}
              />
            </span>
            .
          </motion.h1>

          <p className="mt-7 max-w-xl font-serif text-[19px] leading-[1.55] text-[var(--ink-secondary)]">
            O SmartApply lê seu perfil do LinkedIn, identifica o que está te impedindo de aparecer
            mais nas buscas certas, sugere reescritas concretas pra headline e summary, e gera
            posts no seu estilo. Você escolhe qual IA usar (o Gemini tem 1500 chamadas grátis por
            dia). Seu PDF roda em memória e some quando a sessão fecha, sua chave nunca vai pro
            nosso banco.
          </p>

          <div className="mt-9 flex flex-wrap items-center gap-5">
            <a
              href={APP_URL}
              className="inline-flex items-center gap-2 rounded-sm bg-[var(--ink-primary)] px-6 py-3 font-sans text-sm font-medium text-[var(--bg-paper)] transition-opacity hover:opacity-90"
            >
              Começar análise
              <span aria-hidden>→</span>
            </a>
            <a
              href="#how"
              className="font-sans text-sm text-[var(--ink-secondary)] underline-offset-4 hover:text-[var(--ink-primary)] hover:underline"
            >
              Ver como funciona ↓
            </a>
          </div>

          {/* Margin note lateral, assinatura visual */}
          <div className="mt-12 max-w-md border-l-2 border-[var(--accent-saffron)] pl-4">
            <p className="font-sans text-sm italic leading-relaxed text-[var(--ink-secondary)]">
              "O objetivo é simples: mais gente certa vendo seu perfil, mais impressões nos seus
              posts, mais conversas que abrem porta. A ferramenta é técnica, mas o resultado é
              visibilidade real no LinkedIn."
            </p>
            <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--ink-tertiary)]">
              princípio fundador
            </p>
          </div>
        </div>

        {/* Coluna direita: preview tipográfico do "que vai sair" */}
        <aside className="relative">
          <motion.div
            initial={{ opacity: 0, x: 12 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.55, delay: 0.2, ease: 'easeOut' }}
            className="card-paper-strong relative rounded-sm px-6 py-7"
            style={{ borderLeft: '3px solid var(--accent-crimson)' }}
          >
            <header className="flex items-baseline justify-between">
              <Stamp variant="critical">finding · crítico</Stamp>
              <span className="font-mono text-[10px] tabular-nums text-[var(--ink-muted)]">
                F.03
              </span>
            </header>
            <h3 className="mt-4 font-serif text-xl text-[var(--ink-primary)]">
              Headline lista 12 ferramentas, mas nenhum cargo claro
            </h3>
            <p className="mt-2 font-sans text-sm leading-relaxed text-[var(--ink-secondary)]">
              Recrutador busca por cargo e senioridade, não por arsenal de ferramentas. Como a sua
              começa com "Figma, Sketch, Adobe XD...", você está caindo no terceiro lote dos
              resultados quando alguém procura "Senior Product Designer".
            </p>
            <div className="mt-5 border-t border-[var(--border-subtle)] pt-4">
              <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--ink-tertiary)]">
                reescrita · opção A
              </p>
              <p className="mt-2 font-serif text-[15px] leading-[1.55] text-[var(--ink-primary)]">
                Senior Product Designer em fintech B2B, focada em sistemas de design escaláveis e
                redução de fricção no onboarding.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 12 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.55, delay: 0.4, ease: 'easeOut' }}
            className="card-paper relative mt-5 rounded-sm px-5 py-4"
            style={{ borderLeft: '3px solid var(--accent-forest)' }}
          >
            <Stamp variant="positive">força detectada</Stamp>
            <p className="mt-2 font-serif text-base text-[var(--ink-primary)]">
              Sua trajetória mostra evolução clara de UX Research pra Product Design ao longo de
              oito anos, com cases publicados na sua própria newsletter.
            </p>
          </motion.div>

        </aside>
      </div>
    </section>
  );
}
